<div class="app-container">
  <page-header [icon]="'far-users'" [title]="'customers'">
    <ng-container class="header-button">
      <btn
        [routerLink]="['/customer']"
        [classes]="['btn-first', 'float-right']"
        [icon]="'far-plus'"
        [label]="'customers.create'"
        [title]="'customers.create' | translate"
        [dataCyAttribute]="'add-customer'"
      ></btn>
      <app-exports #exportsModal [entity]="'customers'" data-cy="exports"></app-exports>
    </ng-container>
  </page-header>

  <section class="content">
    <app-filter-form
      [filters]="queryFilters()"
      [filtersForExport]="queryFilters()"
      [entity]="'customers'"
      (onClearClick)="clearFilters()"
      (onExportResult)="queryCustomers.refetch()"
      (onCreateModalHidden)="exportsModal.showChildModal()"
      [isFilterInvisible]="true"
      (onSubmit)="queryCustomers.refetch()"
      [isExportButtonShown]="true"
      [loading]="areCoreDataLoading()"
      [tags]="queryTags.data()"
      [totalItems]="totalItems()"
      [isShowingTags]="true"
    >
      <div class="container-fluid">
        <div class="row">
          <form-row-input
            class="col-4 ps-0"
            [icon]="'far-user'"
            [model]="filters().fulltext"
            (modelChange)="setFilters('fulltext', $event)"
            (keydown.enter)="queryCustomers.refetch({ force: true })"
            [label]="'fulltext'"
            [dataCyAttribute]="'customer-name-filter'"
          ></form-row-input>
          <form-row-select-multiple
            class="col-2"
            [label]="'tags'"
            [options]="queryTags.data()"
            [selectedValues]="filters().tags"
            (selectedValuesChange)="setFilters('tags', $event)"
            [isTags]="true"
            [dataCyAttribute]="'customer-tags-filter'"
          ></form-row-select-multiple>
          <form-row-select-multiple
            class="col-2"
            [label]="'tagsNegate'"
            [options]="queryTags.data()"
            [selectedValues]="filters().tagsNegate"
            (selectedValuesChange)="setFilters('tagsNegate', $event)"
            [isTags]="true"
            [dataCyAttribute]="'customer-tagsNegate-filter'"
          ></form-row-select-multiple>
          <form-row-select
            class="col-2"
            [label]="'salesman'"
            [options]="salesmen"
            [model]="filters().salesman"
            (modelChange)="setFilters('salesman', $event)"
            [dataCyAttribute]="'customer-salesman-filter'"
          ></form-row-select>
          <form-row-select
            class="col-2 pe-0"
            [label]="'priceLevel.title'"
            [options]="priceLevels"
            [model]="filters().priceLevel"
            (modelChange)="setFilters('priceLevel', $event)"
            [dataCyAttribute]="'customer-price-level-filter'"
          ></form-row-select>
        </div>
      </div>
    </app-filter-form>

    @if (!areCoreDataLoading()) {
      <app-base-listing
        [listName]="'customers'"
        [query]="queryCustomers"
        [columns]="listingColumns"
        [selectedColumns]="listingColumns"
        [sortProp]="sortProp"
        [sortDir]="sortDir"
      ></app-base-listing>
    }
  </section>
</div>
